
/**
 * If value exists in array, return the array item.
 * If it doesnt exist in the array, return the default value.
 * If not default value, return the first item in the array.
 * If no items in the array, return ''.
 * @param value value to search
 * @param array array where to search
 * @param defaultValue default return value
 * @returns
 */
function existInArray<T>(value: T, array: { value: T}[], defaultValue: T) {
    if (value) {
        // eslint-disable-next-line eqeqeq
        const index = array.findIndex((element) => element.value == value)
        if (index >= 0) return array[index].value
    }
    if (defaultValue) return defaultValue
    if (array && array.length > 0 && array[0]) return array[0].value
    return ''
}

/**
 * If value exists in array, return the array item.
 * If it doesnt exist in the array, return the default value.
 * If not default value, return the first item in the array.
 * If no items in the array, return ''.
 * @param key where to search value
 * @param value value to search
 * @param config config where to search
 * @param defaultValue default return value
 * @returns
 */
function isInConfig<T>(
    key: string,
    toFindValue: string,
    configs: { key: string, value: Record<string, T> }[],
    defaultValue?: T,
) {
    if (key && toFindValue && configs) {
        const item = configs.find((config) => config.key === key)
        if (item) {
            try {
                const {
                    value: { [toFindValue]: value },
                } = item
                if (value) return value
            } catch (e) {
                console.error((e as Error).message)
            }
        }
    }

    if (defaultValue) {
        return defaultValue
    }

    return ''
}
    
export type KeyDataForm<F> = keyof F
export type ValueDataForm<F> = F[keyof F]
export type DataValidatorFn<F> = (
    key: KeyDataForm<F>,
    value: ValueDataForm<F>,
    data: F,
) => string | undefined
export type FormValidation<F> = Partial<Record<KeyDataForm<F>, string>>

function validate<F extends Record<string, unknown>>(
    data: F,
    validator: DataValidatorFn<F>,
): FormValidation<F> {
    return Object.keys(data).reduce((output, field: KeyDataForm<F>) => {
        const error = validator(field, data[field], data)

        if (!error) {
            return output
        }

        return {
            ...output,
            [field]: error,
        }
    }, {} as FormValidation<F>)
}

export {
    existInArray,
    isInConfig,
    validate,
}
